import { clsx, type ClassValue } from 'clsx'

/**
 * Joins class names. Deliberately without tailwind-merge (about 10 kB gzipped, spec 004 budget):
 * components offer variants and props instead of callers overriding their utilities, so a
 * caller's `className` adds classes and never needs to win over a conflicting one.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs)
}
